import { apiGetAuth } from '@/utils/api'
import { API_BANK } from '@/utils/api-url'
import {
  notificationDanger
} from '@/utils/notification'

const state = {
  bank_list: { data: [] },
  bank_installment_list: { data: [] },
  meta_filter: {
    order_by: 'updated_at',
    sort_by: 'desc'
  }
}

const mutations = {
  "SET_BANK_LIST": (state, payload) => {
    state.bank_list = payload
  },
  "SET_BANK_INSTALLMENT_LIST": (state, payload) => {
    state.bank_installment_list = payload
  },
  "SET_META_FILTER": (state, payload) => {
    state.meta_filter = payload
  }
}

const actions = {
  async getBankList(context, payload) {
    try {
      const response = await apiGetAuth(API_BANK.LIST, payload)
      context.commit('SET_BANK_LIST', response.data)
    } catch (err) {
      notificationDanger(err)
    }
  },
  async getBankInstallment(context, payload) {
    try {
      const response = await apiGetAuth(API_BANK.LIST_BANK_INSTALLMENT, payload)
      context.commit('SET_BANK_INSTALLMENT_LIST', response.data)
    } catch (err) {
      notificationDanger(err)
    }
  }
}

const getters = {
  get_bank_list: state => {
    return state.bank_list
  },
  get_bank_installment_list: state => {
    return state.bank_installment_list
  },
  meta_filter: state => {
    return state.meta_filter
  }
}

const namespaced = true
export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}
